import React from 'react'
import BrazilRugbyLeagueComp from '../../components/sponsorships/BrazilRugbyLeague'

const BrazilRugbyLeague = () => {
  return (
    <BrazilRugbyLeagueComp/>
  )
}

export default BrazilRugbyLeague